import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { SettingsStorageService } from './settings-storage.service'
import { FacilitySelectionBehaviour, LocalSettings } from './local-settings'
import { Observable } from 'rxjs'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ElderAuthModule } from '@elderbyte/ngx-auth'
import { MatFormFieldModule } from '@angular/material/form-field'
import { FormsModule } from '@angular/forms'
import { AsyncPipe } from '@angular/common'
import {
  ElderTabModule,
  ElderCardModule,
  ElderSelectModule,
  ElderThemeModule,
  ElderBasicPaneLayoutComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneTitleComponent,
  ElderPaneComponent,
  ElderLanguageSwitcherComponent,
} from '@elderbyte/ngx-starter'
import { MatTabsModule } from '@angular/material/tabs'
import { FacilitySelectDirective } from '../facilities/facility-select.directive'
import { FacilitySelectionBehaviourSelect } from './facility-selection-behaviour-select.directive'

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  imports: [
    MatTabsModule,
    ElderTabModule,
    ElderCardModule,
    FormsModule,
    ElderSelectModule,
    MatFormFieldModule,
    ElderThemeModule,
    ElderAuthModule,
    AsyncPipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneContentComponent,
    ElderPaneHeaderComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
    ElderPaneComponent,
    FacilitySelectDirective,
    FacilitySelectionBehaviourSelect,
    ElderLanguageSwitcherComponent,
  ],
})
export class SettingsComponent implements OnInit, OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(private settingsService: SettingsStorageService) {}

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public get settings$(): Observable<LocalSettings> {
    return this.settingsService.localSettings$
  }

  public save(settings: LocalSettings): void {
    this.settingsService.localSettings = settings
  }

  protected readonly FacilitySelectionBehaviour = FacilitySelectionBehaviour
}
